import LocalizedStrings from 'react-localization';

export default new LocalizedStrings({
  il:{
    ignoreRelated: ["הגדרות משפטיות", ],
    stats: {
      results: "תוצאות"
    },
    searchWithin: {
      title: "חיפוש בתוך התוצאות",
      placeholder: "יש לכם שאלה? כתבו כאן",
    },
    post: {
      plural: "כל המסמכים",
      markText: "סמן טקסט",
      related: "אולי יעניין אותך גם:",
      findRelated: "חיפוש דפים דומים",
    },
    menu: {
      title: "תפריט",
      about: "אודות",
      contact: "צור קשר",
      features: "יכולות האתר",
      contact2: "לתיאום פגישה עם עורך דין חייגו 077-4008177"
    },
    search: {
      clear: "נקה הכל",
      action: "חפש",
      placeholder: "יש לכם שאלה? כתבו כאן",
      noResults: "אין תוצאות"
    },
    recent: {
      posts: "נצפו לאחרונה",
      searches: "היסטוריית חיפוש"
    },
    pagination: {
      previous: "הקודם",
      next: "הבא",
      first: 'ראשון',
      last: 'אחרון',
    },
    filters: {
      title: "חיפוש מתקדם",
      clear: "נקה פילטרים",
      category: "קטגוריה",
      areas: "תחומים ראשיים",
      done: "הצג תוצאות",
    },
    areas: {
      verdict: "פסיקה",
      legislation: "חקיקה",
    },
    tags: {
      title: "תחומי משנה",
      popular: "חיפוש לפי נושא",
      findMore: "חיפוש מהיר...",
    }
  },
});
